export const updateUrlWithSearchHash = (url: string, searchString: string) => {
    const [beforeHash] = url.split('#');
    return `${beforeHash}#search=${searchString}`;
};
